import React from 'react';
import { ProfilesTabParamList } from '../../../../../utils/appNavigationNames';
import { RouteProp } from '@react-navigation/native';
import PendingFileContent from './PendingFileContent';
import { BulkAddClientRecord } from './types';
import ReviewAndEditContent from './ReviewAndEditContent';

export type BulkAddClientRecordsScreenOwnProps = {};

export type BulkAddClientRecordsScreenProps = BulkAddClientRecordsScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'bulk-add-client-records'>;
};

const BulkAddClientRecordsScreen: React.FC<BulkAddClientRecordsScreenProps> = (_props) => {
    const [initialCSVData, setInitialCSVData] = React.useState<BulkAddClientRecord[] | null>(null);
    return initialCSVData === null ? (
        <PendingFileContent onUpload={setInitialCSVData} />
    ) : (
        <ReviewAndEditContent
            initialRecords={initialCSVData}
            onReupload={() => {
                setInitialCSVData(null);
            }}
        />
    );
};

export default React.memo(BulkAddClientRecordsScreen);
